import { AuthenticationAPI } from '@/library/entities/core/data/authentication.js';
import { COUNTRY_ID, COUNTRY_SWEDEN_ID, COUNTRY_UAE_ID, REGION, REGIONS, ROOT_URL } from '@/data/constants.js'
import fetcher from '@/data/fetcher.js';
import { searchParamsFromObject } from '@/data/utils.js';



class TransactionAPI {
  static async search({ query = '', offset = 0, limit = 50, instrument_name = '', person_id = '' }) {
    const params = searchParamsFromObject({ query, offset, limit, instrument_name, person_id }).toString();
    const transactionURL = `${ROOT_URL}/api/v1/market/transactions/search/`
    const url = `${transactionURL}?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }
}

class InstrumentAPI {
  static getCurrencyName(country_id) {
    if (country_id === COUNTRY_SWEDEN_ID) {
      return 'SEK'
    } else if (country_id === COUNTRY_UAE_ID) {
      return 'AED'
    }
    return 'aed'
  }
  static async getHistoricalPriceListByISIN(isin) {
    const params = searchParamsFromObject({ isin }).toString();
    const url = `${ROOT_URL}/api/v1/market/historical-prices/isin/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }
  static async getHistoricalPriceListByTicker(ticker, limit = 90) {
    const params = searchParamsFromObject({ ticker, limit }).toString();
    const url = `${ROOT_URL}/api/v1/market/historical-prices/isin/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }

  static async getList({
    country_id = COUNTRY_ID, offset = 0, limit = '', sort_by = '', query = '', market_slug = '', sector_id = ''
  }) {
    const params = searchParamsFromObject({
      country_id,
      offset,
      limit,
      sort_by,
      query,
      market_slug,
      sector_id,
    }).toString();

    const url = `${ROOT_URL}/api/v1/market/instruments/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }

  static async getItem({ instrument_id, country_id = COUNTRY_UAE_ID }) {
    const params = searchParamsFromObject({ instrument_id, country_id }).toString();
    const url = `${ROOT_URL}/api/v1/market/instruments/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    const item = data[0]
    return item;
  }

  static async getItemBySlug({ instrument_slug, country_id = COUNTRY_UAE_ID }) {
    const params = searchParamsFromObject({ instrument_slug, country_id }).toString();
    const url = `${ROOT_URL}/api/v1/market/instruments/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    const item = data[0]
    return item;
  }

  static async generateStaticParams(country_id = COUNTRY_UAE_ID) {
    if (country_id != COUNTRY_ID) return []
    const instrumentList = await this.getList({ country_id, limit: 20 })
    const params = []
    instrumentList.forEach(element => {
      if (element.slug) {
        params.push({
          instrumentSlug: element.slug,
        })
      }
    })

    return params
  }

  static async generateStaticParamsForFilter() {
    return [
      { filters: 'page=1' },
      { filters: 'page=2' },
      { filters: 'page=3' },
      { filters: 'page=4' },
      { filters: 'page=5' },
    ]
  }
}

class SectorAPI {
  // TODO: Fetch from API
  static sectors = {
    'uae': [
      // { 
      //   name: 'All', 
      //   id: 'null', 
      //   backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/white-and-black-round-pendant-Ass0DusYDk4_s8eyqFy.jpg?tr=w-600,h-400,f-auto,pr-true,false',  
      // },
      {
        name: 'Financials',
        id: 6,
        slug: 'financials',
        description: 'Financials are the backbone of the economy. They are the companies that provide financial services to businesses and individuals.',
        alt: 'Financial building',
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/city-buildings-during-night-time-41J9-JTIP-c_yKUQcU4.jpg?tr=w-600,h-400,f-auto,pr-true,false'
      },
      {
        name: 'Real Estate',
        slug: 'real-estate',
        id: 2,
        description: 'Real Estate is the sector that deals with the buying, selling, and renting of properties.',
        alt: 'Real Estate building',
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/aerial-photography-of-rural-r3WAWU5Fi5Q_NlCC8lU.jpg?tr=w-600,h-400,f-auto,pr-true,false'
      },
      {
        name: 'Utilities',
        slug: 'utilities',
        id: 7,
        description: 'Utilities are the companies that provide essential services to businesses and individuals.',
        alt: 'Utility building',
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/blue-and-clear-body-of-water-K785Da4A_JA_bS0DLDE.jpg?tr=w-600,h-400,f-auto,pr-true,false'
      },
      {
        name: 'Materials',
        slug: 'materials',
        id: 8,
        description: 'Materials are the companies that provide materials to businesses and individuals.',
        alt: 'Material building',
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/man-wearing-gloves-and-mask-holding-iron-qvCQCvPSCaw_DFvXx1w.jpg?tr=w-600,h-400,f-auto,pr-true,false'
      },
      {
        name: 'Communication Services',
        slug: 'communication-services',
        id: 9,
        description: 'Communication Services are the companies that provide communication services to businesses and individuals.',
        alt: 'Communication Services building',
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/a-close-up-of-a-cell-phone-with-a-blue-background-1PpyUZceg_I_tZJ1ndr.jpg?tr=w-600,h-400,f-auto,pr-true,false'
      },
      {
        name: 'PrJSC',
        slug: 'private-joint-stock-companies-prjsc',
        id: 1,
        description: 'Private Joint Stock Companies (PRJSC) are the companies that are privately owned and have a public listing on the stock exchange.',
        alt: 'Private Joint Stock Companies building',
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/private-signage-door-u5Zt-HoocrM.jpg?tr=w-600,h-400,f-auto,pr-true,false'
      },
      {
        name: 'Industrials',
        slug: 'industrials',
        id: 3,
        description: 'Industrials are the companies that provide industrial services to businesses and individuals.',
        alt: 'Industrial building',
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/vehicles-near-buildings-at-night-time-VmX3vmBecFE_LO3bcKh.jpg?tr=w-600,h-400,f-auto,pr-true,false'
      },
      {
        name: 'Consumer Discretionary',
        slug: 'consumer-discretionary',
        id: 4,
        description: 'Consumer Discretionary are the companies that provide discretionary services to businesses and individuals.',
        alt: 'Consumer Discretionary building',
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/black-and-silver-analog-watch-1ZHw4bwCAys_JE3bf2I.jpg?tr=w-600,h-400,f-auto,pr-true,false'
      },
      {
        name: 'Consumer Staples',
        slug: 'consumer-staples',
        id: 5,
        description: 'Consumer Staples are the companies that provide staple services to businesses and individuals.',
        alt: 'Consumer Staples building',
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/pile-of-vegetables-QvkAQTNj4zk_eLftiS1.jpg?tr=w-600,h-400,f-auto,pr-true,false'
      },
    ],
    'scandinavia': [
      // { 
      //   name: 'Alla', 
      //   id: 'null', 
      //   backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/white-and-black-round-pendant-Ass0DusYDk4_s8eyqFy.jpg?tr=w-600,h-400,f-auto,pr-true,false', 
      //   alt: 'Medical Mask',
      //   description: 'Utforska alla branscher inom finansindustrin på en och samma plats. Vi samlar nyheter, analyser och uppdateringar från olika sektorer för att ge dig en helhetsbild av den skandinaviska finansmarknaden.'
      // },
      {
        name: 'Finans',
        id: 6,
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/city-buildings-during-night-time-41J9-JTIP-c_yKUQcU4.jpg?tr=w-600,h-400,f-auto,pr-true,false',
        alt: 'Financial building',
        slug: 'finans',
        description: 'Håll dig uppdaterad om den senaste utvecklingen inom finanssektorn, inklusive banker, investeringar, kapitalförvaltning och börsanalyser. Vi erbjuder djupgående insikter och marknadstrender för investerare och finansproffs.'
      },
      {
        name: 'Industri',
        id: 3,
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/white-and-black-round-pendant-Ass0DusYDk4_s8eyqFy.jpg?tr=w-600,h-400,f-auto,pr-true,false',
        alt: 'Face mask',
        slug: 'industri',
        description: 'Följ den senaste utvecklingen inom industri och tillverkning, från automation och produktionsoptimering till innovationer och hållbarhetsinitiativ. Få insikter om bolag och trender som formar framtidens industriella landskap.'
      },
      {
        name: 'Energi & Kraft',
        id: 20,
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/two-square-blue-led-lights-ImcUkZ72oUs_lJxufu0.jpg?tr=w-600,h-400,f-auto,pr-true,false',
        alt: 'Electricity flowing through air',
        slug: 'energi-kraft',
        description: 'Få de senaste nyheterna inom energisektorn, inklusive olja, gas, förnybar energi och elproduktion. Håll dig informerad om marknadstrender, investeringar och hållbara lösningar som påverkar energibranschen globalt.'
      },
      {
        name: 'Medicinteknik',
        id: 16,
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/person-holding-silver-and-black-hand-tool-XknuBmnjbKg.jpg?tr=w-600,h-400,f-auto,pr-true,false',
        alt: 'Medical Tools',
        slug: 'medicinteknik',
        description: 'Upptäck den senaste utvecklingen inom medicinteknik och hälsoteknik. Läs om innovationer, investeringar och företag som driver branschen framåt med ny avancerad teknologi och lösningar för sjukvård och medicinsk behandling.'
      },
      {
        name: 'Finansiella tjänster',
        id: 27,
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/brown-and-white-concrete-building-7-gaPkhIgqs_6U08Sir.jpg?tr=w-600,h-400,f-auto,pr-true,false',
        alt: 'Bank offices from above',
        slug: 'finansiella-tjanster',
        description: 'Hitta de senaste uppdateringarna om finansiella tjänster, inklusive försäkringar, lån, betalningslösningar och digital bankverksamhet. Få insikter om företag och teknologier som revolutionerar den finansiella sektorn.'
      },
      {
        name: 'Konsumentprodukter',
        id: 17,
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/person-using-laptop-FlPc9_VocJ4_Dk25OnE.jpg?tr=w-600,h-400,f-auto,pr-true,false',
        alt: 'People pointing to a laptop',
        slug: 'konsumentprodukter',
        description: 'Håll koll på de senaste trenderna inom konsumentprodukter, från elektronik och mode till livsmedel och hållbara varor. Följ företag, innovationer och marknadsutveckling inom konsumentvarubranschen.'
      },
      {
        name: 'Retail',
        id: 26,
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/woman-near-pigeons-CCx6Fz_CmOI.jpg?tr=w-600,h-400,f-auto,pr-true,false',
        alt: 'A fashionable woman near pigeons in a urban area',
        slug: 'retail',
        description: 'Läs om de senaste förändringarna inom retail och detaljhandel, inklusive e-handel, butiksutveckling och konsumentbeteende. Upptäck strategier och teknologier som driver branschens framtid.'
      },
      {
        name: 'Teknik',
        id: 12,
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/silver-macbook-paSLTZpHCdo_7dMbU09.jpg?tr=w-600,h-400,f-auto,pr-true,false',
        alt: 'A silver macbook',
        slug: 'teknik',
        description: 'Utforska den dynamiska tekniksektorn, från AI och mjukvaruutveckling till hårdvara och innovation. Håll dig uppdaterad om startups, teknologitrender och investeringar inom tech-industrin.'
      }
    ]
  }
  static getListByRegion(region) {
    return SectorAPI.sectors[region]
  }
}

class InstrumentEditorAPI {
  static async getList({ offset = 0, limit = 20, search = '' }) {
    const params = searchParamsFromObject({
      offset, limit, search,
    }).toString();
    let url = `${ROOT_URL}/api/v1/market/editor/instruments/?${params}`
    const res = await AuthenticationAPI.get(url);
    const data = await res.json();
    return data;
  }

  static async getItem({ id }) {
    let url = `${ROOT_URL}/api/v1/market/editor/instruments/${id}/`
    const res = await AuthenticationAPI.get(url);
    const data = await res.json();
    return data;
  }

  static async updateItem({ id, payload }) {
    let url = `${ROOT_URL}/api/v1/market/editor/instruments/${id}/`
    const res = await AuthenticationAPI.patch(url, payload, null, 'form');
    const data = await res.json();
    return data;
  }
}

class SectorEditorAPI {
  static async getList({ search = '', offset = 0, limit = 20 }) {
    const params = searchParamsFromObject({
      offset, limit, search
    }).toString();
    let url = `${ROOT_URL}/api/v1/market/editor/sectors/?${params}`
    const res = await AuthenticationAPI.get(url);
    const data = await res.json();
    return data;
  }

  static async getItem({ id }) {
    let url = `${ROOT_URL}/api/v1/market/editor/sectors/${id}/`
    const res = await AuthenticationAPI.get(url);
    const data = await res.json();
    return data;
  }

  static async updateItem({ id, payload }) {
    let url = `${ROOT_URL}/api/v1/market/editor/sectors/${id}/`
    const res = await AuthenticationAPI.patch(url, payload, null, 'form');
    const data = await res.json();
    return data;
  }
}

export {
  TransactionAPI,
  InstrumentAPI,
  InstrumentEditorAPI,
  SectorAPI,
  SectorEditorAPI,
}